import { now } from 'utilities/time';
import { percent } from 'utilities/formatting';
import { PLAYER_EVENT } from 'constants/events';
import { PROGRESS_REPORTING_INTERVAL } from 'configuration/defaults';

export class PlaybackTracker {
    constructor(playerAdapter, progressInterval) {
        this.lastTimeReport = 0;
        this.nextTimeReport = 0;
        this.playbackStarted = false;
        this.progressInterval = progressInterval || PROGRESS_REPORTING_INTERVAL;
    }

    getEventResponses(eventName, player) {
        const actions = [],
            playTime = player.playTime;

        switch(eventName) {
            case PLAYER_EVENT.PLAY:
                actions.push({ action: 'Resume' });
                break;
            case PLAYER_EVENT.PAUSE:
                actions.push({ action: 'Pause' });
                break;
            case PLAYER_EVENT.SEEKED:
                actions.push({ action: 'Seeked' });
                break;
            case PLAYER_EVENT.ENDED:
                actions.push({ action: this.getEndedAction(player) });
            case PLAYER_EVENT.TIME_UPDATE:
                if (this.shouldReportPlay(playTime)) {
                    this.playbackStarted = true;
                    actions.push({ action: 'Play' });
                }

                if (this.shouldReportProgress(playTime)) {
                    actions.push({ action: 'Progress', data: this.getProgressParameters(player) });
                    this.markProgress(playTime);
                }

                break;
        }

        return actions;
    }

    markProgress(playTime) {
        this.lastTimeReport = playTime;
        this.nextTimeReport = playTime + this.progressInterval;
    }

    getProgressParameters(player) {
        return {
            'Video Elapsed Difference': this.getElapsedDifference(player.playTime),
            'Video Slice Play Time Accrued': player.slicePlayTime(false),
            'Progress Interval': this.progressInterval
        }
    }

    getPlaybackStats(player) {
        const stats = {
            'Play Time Accrued': player.playTime,
            'Video Accrued': player.playTime,
            'Live Video': false
        };

        if (player.currentTime <= player.duration) {
            stats['Video Offset'] = player.currentTime;
            stats['Video Duration'] = player.duration;
            stats['Video Percent Complete'] = percent(player.currentTime / player.duration);
        }

        return stats;
    }

    getEndedAction(player) {
        if (player.playTime > player.duration) {
            return 'End-over';
        } else if (player.duration - player.playTime < 0.5) {
            return 'End-complete';
        } else {
            return 'End-under';
        }
    }

    shouldReportPlay = playTime => !this.playbackStarted && playTime > 0;
    shouldReportProgress = playTime => this.lastTimeReport !== playTime && playTime >= this.nextTimeReport;
    getElapsedDifference = playTime => playTime - this.lastTimeReport;
}